import { render, staticRenderFns } from "./EditorBlockEmbedPdf.vue?vue&type=template&id=3f042c8c&scoped=true"
import script from "./EditorBlockEmbedPdf.vue?vue&type=script&lang=js"
export * from "./EditorBlockEmbedPdf.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockEmbedPdf.vue?vue&type=style&index=0&id=3f042c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f042c8c",
  null
  
)

export default component.exports